import React from "react";
import { Box, Typography, Grid, Link, Stack, Divider } from "@mui/material";
import imgUrl from "../assets/images/imgUrl";
import pdfFile from "../assets/pdf/Dure_Technologies_PrivacyPolicy_Terms_Final.pdf";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#0F2142",
        color: "#fff",
        px: { xs: 3, md: 8 },
        py: 5,
      }}
    >
      <Grid
        container
        spacing={4}
        alignItems="center"
        justifyContent="space-between"
        direction={{ xs: "column", md: "row", sm: "row" }}
      >
        {/* Left side: Logo + Company Info */}
        <Grid size={{ xs: 12, md: 9, sm: 9 }}>
          <Stack spacing={1}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: 1,
              }}
            >
              <img src={imgUrl.dureLogo} alt="Logo" style={{ height: 30 }} />
              <Typography variant="body2">2025</Typography>
              <Typography variant="body2" sx={{ color: "#b0b0b0" }}>
                |
              </Typography>
              <Link
                href="https://vitafi.ai/healthcare.html"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                variant="body2"
                sx={{ color: "#b0b0b0" }}
              >
                Vitafi
              </Link>
              <Link
                variant="body2"
                href="https://cre-ait.com/"
                target="_blank"
                underline="hover"
                rel="noopener noreferrer"
                sx={{ color: "#b0b0b0" }}
              >
                Cre-AIT
              </Link>
              <Link
                variant="body2"
                href="https://alopexia.com/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: "#b0b0b0" }}
              >
                Alopexia
              </Link>
            </Box>
            <Typography variant="caption" sx={{ color: "#ccc" }}>
              Copyright ©2025{" "}
              <Link
                href="#"
                underline="hover"
                sx={{ color: "#fff", textDecoration: "underline" }}
              >
                Dure Technologies
              </Link>
              . All rights reserved.
            </Typography>
          </Stack>
        </Grid>

        {/* Right side: Social Icons + Policy Links */}
        <Grid size={{ xs: 12, md: 3, sm: 3 }}>
          <Stack
            spacing={2}
            direction={{ xs: "column", md: "column" }}
            alignItems={{ xs: "center", md: "center" }}
            justifyContent={{ xs: "flex-start", md: "flex-end" }}
            sx={{ width: "100%" }}
          >
            {/* Social Icons */}
            <Box
              sx={{
                display: "flex",
                gap: 1,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={imgUrl.twitterIcon}
                className="footerSocialIcon"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.open(
                    "https://x.com/dure_tech?s=11&t=04JdexjAqU6KZi3ilJ_UsA",
                    "_blank",
                  )
                }
                alt="Twitter"
              />
              <img
                src={imgUrl.mailIcon}
                style={{ cursor: "pointer" }}
                className="footerSocialIcon"
                alt="Email"
              />
              <img
                src={imgUrl.linkedInIcon}
                onClick={() =>
                  window.open(
                    "https://www.linkedin.com/company/dure-technologies?trk=blended-typeahead",
                    "_blank",
                  )
                }
                style={{ cursor: "pointer" }}
                className="footerSocialIcon"
                alt="LinkedIn"
              />
            </Box>
            {/* Policy Links */}
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
              <Link
                href={pdfFile}
                download
                underline="hover"
                sx={{ color: "#ccc", fontSize: 14 }}
              >
                Privacy Policy
              </Link>
              <Link
                href={pdfFile}
                download
                underline="hover"
                sx={{ color: "#ccc", fontSize: 14 }}
              >
                Terms of Use
              </Link>
            </Box>
          </Stack>
        </Grid>
      </Grid>

      {/* ── Address Section ── */}
      <Box
        className="footerAddressSection"
        sx={{
          mt: 4,
          display: "flex",
          justifyContent: {
            xs: "center", // centered on mobile
            sm: "flex-end", // right-aligned on tablet and above
          },
        }}
      >
        <Box
          className="footerAddressInner"
          sx={{
            pr: { xs: 0, sm: 3 },
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "center", sm: "flex-start" },
            width: {
              xs: "100%", // full-width on mobile → stacks column
              sm: "65%", // right-side block on tablet
              md: "40%", // tighter on desktop, aligns under right Grid column
            },
          }}
        >
          {/* India Address */}
          <Box
            className="footerAddressBlock footerAddressBlock--india"
            sx={{
              flex: 1,
              textAlign: { xs: "center", sm: "right" }, // right-align on sm+
              pr: { xs: 0, sm: 2 },
              pb: { xs: 2, sm: 0 },
              width: { xs: "100%", sm: "auto", md: "85%" },
            }}
          >
            <Typography variant="body2" sx={{ color: "#ccc", lineHeight: 1.8 }}>
              101/1102 Centrum IT Park
              <br />
              Wagle Estate, Thane West, Thane
              <br />
              Maharashtra 400604,
              <br />
              India
            </Typography>
          </Box>

          {/* Vertical Divider — hidden on mobile */}
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              borderColor: "#969da7",
              borderRightWidth: 3,
              display: { xs: "none", sm: "block" },
              alignSelf: "stretch",
            }}
          />

          {/* Horizontal Divider — visible only on mobile */}
          <Divider
            sx={{
              borderColor: "#3a4f6e",
              display: { xs: "block", sm: "none" },
              width: "60%",
              my: 1,
            }}
          />

          {/* Switzerland Address */}
          <Box
            className="footerAddressBlock footerAddressBlock--switzerland"
            sx={{
              flex: 1,
              textAlign: { xs: "center", sm: "right" }, // left-align on sm+
              pl: { xs: 0, sm: 2 },
              pt: { xs: 1, sm: 0 },
              width: { xs: "100%", sm: "auto", md: "85%" },
            }}
          >
            <Typography variant="body2" sx={{ color: "#ccc", lineHeight: 1.8 }}>
              Campus Biotech Innovation Park
              <br />
              Av. de Sécheron 15, 1202
              <br />
              Genève
              <br />
              Switzerland
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
